import { render, staticRenderFns } from "./AdminUserLogout.vue?vue&type=template&id=1c8cae68&scoped=true&"
import script from "./AdminUserLogout.vue?vue&type=script&lang=js&"
export * from "./AdminUserLogout.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserLogout.vue?vue&type=style&index=0&id=1c8cae68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cae68",
  null
  
)

export default component.exports